import { Company } from "../gateway/Company/Company";
import { LastAvailable } from "../gateway/LastAvailable/LastAvailable";

export class PopulateLastAvailableDatesUsecase {
    constructor() {
        this.CompanyGateway = new Company();
        this.LastAvailableGateway = new LastAvailable();
    }

    async execute({ accountingId, so } = {}) {
        const payload = this.sanitizeInput({ accountingId, so });
        if (!payload.accountingId || !payload.so) return null;
        const select = {
            accountingId: { $eq: payload.accountingId },
            so: { $eq: payload.so }
        };
        const isPopulate = this.LastAvailableGateway.findOneCollection(select)
            ? true
            : false;
        if (isPopulate) return true;
        this.LastAvailableGateway.deleteMany(select);
        const response = await this.LastAvailableGateway.getLastDates({
            accountingId,
            so
        });
        if (!response?.list) return false;
        this.createMany(response.list, { accountingId: payload.accountingId });
        return true;
    }

    sanitizeInput({ accountingId = "", so = "a" } = {}) {
        const sanitizedAccountingId = String(accountingId).trim();
        const sanitizedSo = String(so).trim();
        return {
            accountingId: sanitizedAccountingId || null,
            so: sanitizedSo || null
        };
    }

    createMany(data = [], fields = {}) {
        const total = data.length;
        if (!total) return false;
        for (let i = 0; i < total; i++) {
            let document = data[i];
            document.date = new Date(document.date);
            const company = this.CompanyGateway.findOneCollection({
                _id: { $eq: document.c }
            });
            if (company) {
                if (
                    document.so == "f" &&
                    (company?.organizationId ||
                        company?.relation?.contaazul ||
                        company?.relation?.omie)
                )
                    document.so = "fin";
            }
            document = { ...document, ...fields };
            this.LastAvailableGateway.create(document);
        }
        return true;
    }
}
